import { useContext } from "react";
import MasterDataContext from "../contexts/MasterDataProvider";

const useMasterData = () => {
  return useContext(MasterDataContext);
};

export default useMasterData;
